const DEFAULT_TYPE = 'image'

export const setImageToOpen = imageElement => {
	localStorage.setItem(
		'image-to-open',
		JSON.stringify({
			gallery: imageElement.getAttribute('data-image-gallery'),
			imageNumber: +imageElement.getAttribute('data-image-number'),
		})
	)
}

const getImageToOpen = () => {
	const imageToOpenString = localStorage?.getItem('image-to-open')
	if (!imageToOpenString) return

	try {
		const imageToOpen = JSON.parse(imageToOpenString)

		localStorage.removeItem('image-to-open')

		return imageToOpen
	} catch (error) {
		console.error(`Error while opening image by default. ${error}`)
	}
}

const initGalleries = async () => {
	await import('fslightbox')

	const imageElements = document.querySelectorAll('[data-image-gallery]')

	imageElements.forEach(imageElement => {
		const galleryName = imageElement.dataset.imageGallery

		if (!fsLightboxInstances[galleryName])
			fsLightboxInstances[galleryName] = new FsLightbox()

		fsLightboxInstances[galleryName].props.sources.push(
			imageElement.dataset['fslightboxLink']
		)

		const galleryImagePath = imageElement.dataset.galleryImagePath
		const galleryImages = imageElement.dataset.galleryImages
			? JSON.parse(imageElement.dataset.galleryImages)
			: null

		if (galleryImagePath && galleryImages) {
			fsLightboxInstances[galleryName].props.sources.push(
				...galleryImages.map(img => `${galleryImagePath}${img}`)
			)
		}

		// якщо не передати тип - бібліотека робить XHR HEAD-запит для кожного source щоб визначити тип
		fsLightboxInstances[galleryName].props.type =
			imageElement.dataset.type ?? DEFAULT_TYPE

		imageElement.addEventListener('click', () => {
			fsLightboxInstances[galleryName].open(+imageElement.dataset.imageNumber)
		})
	})

	const imageToOpen = getImageToOpen()
	if (imageToOpen)
		fsLightboxInstances[imageToOpen.gallery]?.open(imageToOpen.number)
}

export default initGalleries
